import SceneObjectTypeData from "./SceneObjectTypeData";

class ChecklistItemTypeData extends SceneObjectTypeData {
    readonly sceneObjectType = "ChecklistItem" as const;
    checklistItemId: number | null;
    imageUrl: string | null;
    color: string | null;

    constructor(checklistItemId: number | null, imageUrl: string | null, color: string | null) {
        super();
        this.checklistItemId = checklistItemId;
        this.imageUrl = imageUrl;
        this.color = color;
    }
}

export default ChecklistItemTypeData;
